import { Component, OnInit } from '@angular/core';
import { FormArray, UntypedFormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ChangeDetectorRef } from '@angular/core';
import { AfterViewInit, ViewChild } from '@angular/core';
import {MatPaginator as MatPaginator,MatPaginatorModule as MatPaginatorModule, PageEvent as PageEvent } from '@angular/material/paginator';
import {MatTableDataSource as MatTableDataSource,MatTableModule as MatTableModule } from '@angular/material/table';

import { X } from '@angular/cdk/keycodes';
import { ToastrService } from 'ngx-toastr';


import { HttpClient } from '@angular/common/http';
import { debounceTime, distinctUntilChanged, map, mergeMap, startWith, switchMap, catchError } from 'rxjs/operators';
import { Observable, forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-translation',
  templateUrl: './translation.component.html',
  styleUrls: ['./translation.component.css']
})
export class TranslationComponent implements OnInit {
  slugs: any;
  CultureCode: any;
  culture: any;
  optionName = ""
  filteredSluges: any = [];
  showLoader;
  allKeys: any = []
  slug = []
  component = []
  IsKeyIsExisist: boolean = false;
  displayedColumns: string[] = ['key', 'Selected culture', 'Slug Name', 'Component', 'localizationValues'];
  cultureArray: any = []
  pageIndex = 0;
  pageSize = 20;
  AllKeysInSlug = []
  filteredOrders = []
  slugName = ''
  payload2 = {}
  dataSource = new MatTableDataSource<any>();

  /** Bulk "pre-add keys" panel state. */
  showBulkAdd = false;
  bulkAdding = false;
  bulkKeysControl = new FormControl('');

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;


  formFilter = new FormGroup({
    language: new FormControl(),
    slug: new FormControl(),
    options: new FormControl(),
    search: new FormControl('')

  })

  itemsForms: FormGroup = new FormGroup({
    items: new FormArray([]),
  });

  getAll = { components: {}, slugs: {} }
  constructor(private httpClient: HttpClient, private snotifyService: ToastrService, private fb: UntypedFormBuilder, public cdf: ChangeDetectorRef) {
    // this.formFilter.get('search').valueChanges.subscribe(value => {
    //   if(value.length>0){
    //     this.pageIndex = 0

    //   debounceTime(500),
    //   distinctUntilChanged(),
    //     this.Search(value)
    //   }
    //   else{
    //     this.Search('')

    //   }
      
        
    // })
  }


  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.showLoader = true
    this.getAllCulture().subscribe(res => {
      this.cultureArray = res;
      this.CultureCode = this.cultureArray[0].name;
      this.culture = this.cultureArray[0].id;
      this.formFilter.get('language').setValue(this.CultureCode);
      this.getAllKeys();
      this.showLoader = false;

    })


  }

  WhenSelectCulture(obj: any) {
    this.optionName = ''
    this.filteredSluges = []
    this.formFilter.get('slug').reset()
    this.formFilter.get('options').reset()

    this.culture = obj.id
    this.CultureCode = obj.name;
    this.pageIndex = 0
    this.itemsForms.reset()
    this.ListOfKeysValuesForm().clear()
    this.dataSource.data = []
    this.getAllKeys();


  }




  Search(val: any='') {

    if (this.formFilter.get('search').value && this.formFilter.get('search').value.length > 2) {

      let key = this.formFilter.get('search').value

      this.ListOfKeysValuesForm().clear()

      this.payload2 = {

        "pagination": {
          "start": this.pageIndex,
          "totalItemCount": 0,
          "number": this.pageSize,

          "numberOfPages": 0
        },
        "search": {
          "id": 0,
          "key": key,
          "localizationValues": [
            {
              "value": "",
              "cultureId": this.culture,
              "cultureCode": this.CultureCode
            }
          ],
          "component": "",
          "groupId": "",
          "slugInfoId": null,
          "slug": this.slugName,
          "cultureId": this.culture,

        }
      }



      
      this.itemsForms.reset()
      this.ListOfKeysValuesForm().clear()
      this.dataSource.data = [] ;



      this.GetAllKeys(this.payload2).then(res => {
        this.allKeys = res;
        this.IsKeyIsExisist = true
        // this.cdf.detectChanges()
        this.dataSource = new MatTableDataSource<any>(this.allKeys.data);

        this.paginator.length = this.allKeys.totalCount


        this.getFormData()

      }

      )


console.log(this.ListOfKeysValuesForm().value)


    }

    if (!val && this.formFilter.get('search').value.length == 0) {
      this.payload2 = {

        "pagination": {
          "start": this.pageIndex,
          "totalItemCount": 0,
          "number": this.pageSize,

          "numberOfPages": 0
        },
        "search": {
          "id": 0,
          "key": "",
          "localizationValues": [
            {
              "value": "",
              "cultureId": this.culture,
              "cultureCode": this.CultureCode
            }
          ],
          "component": "",
          "groupId": "",
          "slugInfoId": null,
          "slug": this.slugName,
          "cultureId": this.culture,

        }
      }

 this.itemsForms.reset()
      this.ListOfKeysValuesForm().clear()
      this.dataSource.data = [] ;


      this.GetAllKeys(this.payload2).then(res => {
        this.allKeys = res;
        this.IsKeyIsExisist = true
        // this.cdf.detectChanges()
        this.dataSource = new MatTableDataSource<any>(this.allKeys.data);
        this.paginator.length = this.allKeys.totalCount
        this.getFormData()

      }

      )

    }


  }




  submitListOfForm() {
// let mainArray=[]
// this.ListOfKeysValuesForm().value.forEach(x=>{
//   if((mainArray.findIndex(y=>y.id == x.id) == -1) || (mainArray.findIndex(y=>y.id == x.id && y.key ==x.key) != -1)){
//     mainArray.push(x)
//   }
// })
    this.updateLocalizationValues(this.ListOfKeysValuesForm().value)
      .subscribe(res => {
        if (res) {
          this.snotifyService.success("", "Edit is Successful", {
            timeOut: 2500,
            progressBar: true,
            tapToDismiss: true
          });
          
        }
      }), err => {
        this.openNotifyError(err.message ? err.message : 'something went wrong ')

      }
  }


  openNotifyError(message: string) {
    this.snotifyService.error(message, "Error!", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true
    });
  }
  getWithOutSlug(name: any) {
    this.optionName = name
    this.slugName = ''
    this.itemsForms.reset()
    this.ListOfKeysValuesForm().clear()

    this.formFilter.get('slug').reset()

    this.getAllKeys()

  }


  SubmitFormToSearch(value: any) {
    this.formFilter.get('search').reset()
    this.slugName = value
    this.pageIndex = 0
    this.itemsForms.reset()
    this.ListOfKeysValuesForm().clear()
    this.getAllKeys()


  }

  back() { window.history.back() }

  getAllKeys() {


    let payload = {
      "pagination": {
        "start": this.pageIndex,
        "totalItemCount": 0,
        "number": this.pageSize,

        "numberOfPages": 0
      },
      "search": {
        "id": 0,
        "key": "",
        "localizationValues": [
          {
            "value": "",
            "cultureId": this.culture,
            "cultureCode": this.CultureCode
          }
        ],
        "component": "",
        "groupId": "",
        "slugInfoId": null,
        "slug": this.slugName,
        "cultureId": this.culture,

      }
    }

     this.itemsForms.reset()
      this.ListOfKeysValuesForm().clear()
      this.dataSource.data = [] ;

    this.GetAllKeys(payload).then(res => {
      this.allKeys = res;
      this.IsKeyIsExisist = true
      this.dataSource = new MatTableDataSource<any>(this.allKeys.data);
      this.paginator.length = this.allKeys.totalCount
      this.getFormData()



    })

  }
  filterSlug() {

    const filterValue = this.formFilter.get('slug').value.toLowerCase();
    if (Array.isArray(this.slugs)) {
      this.filteredSluges = this.slugs.filter(option => option.name.toLowerCase().includes(filterValue));

    } else {
      this.filteredSluges = this.slugs.list.filter(option => option.title.toLowerCase().includes(filterValue));

    }


  }


  ResetForm() {
    this.optionName = ''
    this.slugName = ''
    this.itemsForms.reset()
    this.ListOfKeysValuesForm().clear()
    this.dataSource.data = []

    this.formFilter.get('options').reset()
    this.formFilter.get('slug').reset()
    this.formFilter.get('search').reset()

    this.pageIndex = 0;
    this.pageSize = 20
    this.getAllKeys()
  }


  onPageChange(event: PageEvent): void {
    //this.optionName = ''


    this.itemsForms.reset()
    this.ListOfKeysValuesForm().clear()
    this.dataSource.data = []

    // this.formFilter.get('options').reset()
    // this.formFilter.get('slug').reset()
    let searchInput = this.formFilter.get('search').value ? this.formFilter.get('search').value : ''
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize
    if (searchInput.length > 2) {
      this.Search(searchInput)
    } else {
      this.getAllKeys()

      //this.formFilter.get('search').reset()
    }



  }



  keysValuesForm(e: any): FormGroup {
    const localizationValuesArray = new FormArray([]);

    if (e.localizationValues && e.localizationValues.length > 0) {
      for (const localizationValue of e.localizationValues) {
        localizationValuesArray.push(this.putLocalizations(localizationValue));
      }
    }

    return new FormGroup({
      id: new FormControl(e.id),
      key: new FormControl(e.key),
      localizationList: new FormGroup({
        localizationValues: localizationValuesArray,
      }),
      component: new FormControl(e.component),
      groupId: new FormControl(e.groupId),
      slugInfoId: new FormControl(e.slugInfoId),
      slug: new FormControl(e.slug)
    });
  }

    putLocalizations(e: any) {

    return new FormGroup({
      value: new FormControl(e.value),
      cultureId: new FormControl(e.cultureId),
      id: new FormControl(e.id),
      cultureCode: new FormControl(e.cultureCode),
    });
  }

  ListOfKeysValuesForm() {

    return this.itemsForms.get("items") as FormArray;
  }

  addObjectToTheList(e: any) {
    this.ListOfKeysValuesForm().push(this.keysValuesForm(e));
  }



  serverData: any = [];
  getFormData() {  
    this.ListOfKeysValuesForm().clear() 
    let tempObj:any={}
    tempObj.localizationValues=[]
    this.allKeys.data.forEach((element: any) => {

       tempObj = {
        id: element.id,
        key: element.key,

        localizationValues: [],
        component: element.component,
        groupId: element.groupId,
        slugInfoId: element.slugInfoId,
        slug: element.slug
      };

      element.localizationValues.forEach(
        (elementSubjectObj: any) => {
          let tempSubObj: any = {
            value: elementSubjectObj.value,
            cultureId: elementSubjectObj.cultureId,
            cultureCode: elementSubjectObj.cultureCode,
            id: elementSubjectObj.id,

          };
          tempObj.localizationValues.push(tempSubObj);
        }
      );

      //this.serverData.push(tempObj);
      this.addObjectToTheList(tempObj)
    });
  }





  public UpsertLocalizations(payload: any) {

    for (let item of payload) {

      if (item.localizationList) {
        item.localizationValues = item.localizationList.localizationValues
        delete item.localizationList
      }

    }
    return this.httpClient.post(`/LocalizationApi/UpsertLocalization`, payload);
  }
  public updateLocalizationValues(payload: any) {
    let items = [];
    let index = 0;
    for (let item of payload) {
      if (item.localizationList) {
        let value = item.localizationList.localizationValues[0].value;
        let valueId = item.localizationList.localizationValues[0].id
        items.push({ value: value, valueId: valueId })
        index++;
        delete item.localizationList
      }
    }
   // this.itemsForms.reset()
    return this.httpClient.post('/LocalizationApi/UpdateBulkLocalizationValue', items)
  }

  /** Registers one shared localization key (all cultures, value = key) via ScanResource. */
  scanResource(key: string) {
    return this.httpClient.post('/Localization/ScanResource', {
      Key: key,
      Component: null,
      Slug: null,
      Group: null,
    });
  }

  /**
   * Pre-adds a whole list of keys up-front so you don't have to wait for each
   * error to fire. Each line becomes a shared key (created for every culture
   * with the key text as the default value); then you translate them in the grid.
   */
  bulkAddKeys() {
    const raw = this.bulkKeysControl.value || '';
    const keys = Array.from(
      new Set(
        raw
          .split('\n')
          .map((k: string) => k.trim())
          .filter((k: string) => !!k),
      ),
    );
    if (!keys.length) {
      this.openNotifyError('Add at least one key (one per line).');
      return;
    }
    this.bulkAdding = true;
    forkJoin(
      keys.map((k: string) => this.scanResource(k).pipe(catchError(() => of(null)))),
    ).subscribe(
      () => {
        this.bulkAdding = false;
        this.bulkKeysControl.reset('');
        this.showBulkAdd = false;
        this.snotifyService.success(
          '',
          `${keys.length} key(s) added — now translate them below`,
          { timeOut: 3000, progressBar: true, tapToDismiss: true },
        );
        this.getAllKeys();
      },
      () => {
        this.bulkAdding = false;
        this.openNotifyError('Something went wrong while adding keys.');
      },
    );
  }

  public GetAllKeys(payload: any) {
    // return this.httpClient.post(`/LocalizationApi/GetAllKeys`, payload);

    return new Promise((resolve, reject) => {
      this.httpClient.post(`/LocalizationApi/GetAllKeys`, payload)
        .subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
    });

  }

  public GetAllPages() {
    ///////////////////////////////////////////////////////////////////////////////////
    return this.httpClient.get(`/Pages/GetAllPagesFlat/${0}/${0}/${2}/${this.culture}`);
  }
  public GetAllPosts() {
    let payload = {
      'categoriesIds': [],

      'pageNo': 0,

      'pageSize': this.pageSize,

      'postsSort': null,

      'searchValue': "",
      'cultureId': this.culture

    }
    ///////////////////////////////////////////////////////////////////////////////////
    return this.httpClient.post(`/BolgArchive/GetPostsForAdmin`, payload);
  }

  public GetAllProducts() {
    ///////////////////////////////////////////////////////////////////////////////////
    return this.httpClient.get(`/ProductApi/GetProductsFlat/${this.culture}/${0}`);
  }


  public GetAllBrand() {


    ///////////////////////////////////////////////////////////////////////////////////
    return this.httpClient.post(`/brands/GetAllBrandFlat/${this.culture}`, {});
  }


  public GetAllCategory() {



    ///////////////////////////////////////////////////////////////////////////////////
    return this.httpClient.get(`/CategoriesApi/GetAllCategoriesFlat/${this.culture}`);
  }

  getAllPages(name) {


    this.optionName = name
    this.formFilter.get('slug').reset()
    this.GetAllPages().subscribe(res => { this.slugs = res; this.filteredSluges = res })

  }

  getAllPosts(name) {

    this.optionName = name
    this.formFilter.get('slug').reset()
    this.GetAllPosts().subscribe(res => { this.slugs = res; this.filteredSluges = this.slugs.list })


  }

  getAllCulture() {



    return this.httpClient.get(`/Sites/GetUsedSiteCulturesByStatus/${2}`);
  }
  getAllProducts(name) {

    this.optionName = name
    this.formFilter.get('slug').reset()
    this.GetAllProducts().subscribe(res => { this.slugs = res; this.filteredSluges = res })
  }
  getAllBrands(name) {

    this.optionName = name
    this.formFilter.get('slug').reset()
    this.GetAllBrand().subscribe(res => { this.slugs = res; this.filteredSluges = res })
  }
  getAllCategory(name) {

    this.optionName = name
    this.formFilter.get('slug').reset()
    this.GetAllCategory().subscribe(res => { this.slugs = res; this.filteredSluges = res })
  }



}







